<header>
  <div class="header-infos">
    <div class="header-logo">
      @if (selectedModuleName != undefined) {
        <mat-icon class="header-menu" aria-hidden="false"
        aria-label="Menu modulos" (click)="openModuleMenu(sidenavModuleMenu)">menu</mat-icon>
      }
      <a class="link-menu" (click)="redirect()">
        <img class="brand" src="assets/images/logo-ToLife.png">
      </a>
    </div>
    <h1 class="module-name" (click)="redirect()"><b>{{ selectedModuleName }} </b></h1>
    <h1 [ngClass]="{'line-left': selectedModuleName != undefined}" class="module-name"
      (click)="redirect()">{{isAuthenticated ? userLoginResponse.healthUnit.healthUnitName : '' }}
    </h1>
  </div>

  @if (isAuthenticated == true) {
    <div class="actions">
      <div class="user-actions">
        <mat-icon aria-hidden="false" aria-label="Menu apps" (click)="openSignatureManager()">
          {{managerIcon}}
        </mat-icon>
        @if (unreadMessages > 0) {
          <mat-icon [matBadge]="unreadMessages" matBadgeColor="accent" matBadgeSize="small"
            aria-hidden="false" aria-label="Menu apps" (click)="openNotification()">notifications
          </mat-icon>
        }
        @if (!unreadMessages) {
          <mat-icon aria-hidden="false" aria-label="Menu apps" (click)="openNotification()">
            notifications
          </mat-icon>
        }
        <mat-icon aria-hidden="false" aria-label="Menu apps"
        (click)="openModuleInfo(sidenavModuleInfos)">apps</mat-icon>
      </div>
      <div class="user-info-container">
        <span class="user-name">
          <b>{{userLoginResponse.userName}}
            @if (userLoginResponse.council) {
              <span> - {{userLoginResponse.council}}</span>
            }
          </b>
        </span>
        <mat-icon aria-hidden="false" aria-label="Informações do usuário"
        (click)="openUserInfo(sidenavUserInfo)">account_circle</mat-icon>
      </div>
    </div>
  }
</header>

@if (!onlineOffline) {
  <div class="offline">
    <span><mat-icon class="offline--icon">wifi_off</mat-icon>Você esta sem conexão com a internet no momento.</span>
  </div>
}

<mat-drawer-container class="container-sidenav" [hasBackdrop]="true">
  <mat-drawer #sidenavModuleMenu class="module-menu-sidenav" mode="over">
    @if (isAuthenticated == true) {
      <app-module-menu [isVisible]="isVisibleModuleMenu"
      [systemMainMenu]="this.systemMainMenu" (closeModuleMenu)=closeModuleMenu()></app-module-menu>
    }
  </mat-drawer>
</mat-drawer-container>

@if (hasSecundaryHeader && episode) {
  <app-secundary-header #secundaryHeader class="secundary-header"
    [episode]="episode" [discriminators]="discriminators" [hasCachedModule]="hasCachedModule"
    [cachedModuleName]="cachedModuleName" [painColorCode]="painColorCode" [gravityColorCode]="gravityColorCode"
    [pain]="pain" [gravity]="gravity" [isClassification]="isClassification" (restartMeasurers)="emitMeasurerRestart()">
  </app-secundary-header>
}


@if (hasSecundaryHeader && !episode) {
  <app-secundary-header-v2 #secundaryHeaderV2 class="secundary-header"
    [name]="name" [socialName]="socialName" [birthDate]="birthDate" [formatedBirth]="formatedBirth" [age]="age"
    [patientCareLinePriorityStruct]="patientCareLinePriorityStruct" [isClassification]="isClassification"
    (restartMeasurers)="emitMeasurerRestart()" [listAllergyStruct]="listAllergyStruct">
  </app-secundary-header-v2>
}

@if (!loadingSignatures) {
  <app-signature-manager [isMenu]="true" [isVisible]="isVisibleSignatureManager"
    [isLoading]="isLoadingSignatureManager" (setManagerIcon)="setManagerIcon($event)"
    (closeManager)="closeSignatureManager()">
  </app-signature-manager>
}

<app-notification [listMessage]="listMessage" [isVisible]="isVisibleNotification" [isLoading]="isLoadingNotification"
  [idSelectedMessage]="idSelectedMessage" (closeNotification)=closeNotification()
  (populateNotification)="populateNotification()" (selectMessage)="selectMessage($event)">
</app-notification>

<mat-drawer-container class="container-sidenav" [hasBackdrop]="true">
  <mat-drawer #sidenavUserInfo class="user-info-sidenav" mode="over" position="end">
    @if (isAuthenticated == true) {
      <app-user-infos [isVisible]="isVisibleUserInfo"
        (closeUserInfo)="closeUserInfo(sidenavUserInfo)" [menuModuleEnum]="menuModuleEnum"
        (savePreviousURL)="setPreviousURL()">
      </app-user-infos>
    }
  </mat-drawer>
</mat-drawer-container>

<mat-drawer-container class="container-sidenav" [hasBackdrop]="true">
  <mat-drawer #sidenavModuleInfos class="module-info-sidenav" mode="over" position="end" autofocus="false">
    @if (isAuthenticated == true) {
      <app-module-infos [isVisible]="isVisibleModule"
      [menuModuleEnum]="this.menuModuleEnum" (closeModuleInfo)="closeModuleInfo()"></app-module-infos>
    }
  </mat-drawer>
</mat-drawer-container>